<template>
    <el-dialog
        :visible.sync="selfVisible"
        title="同步组织选择"
        class="app-container"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <div style="text-align: center">
            <el-transfer
                :render-content="renderFunc"
                filterable
                style="text-align: left; display: inline-block"
                :filter-method="filterMethod"
                filter-placeholder="请输入名称"
                :titles="['组织列表', '已选择']"
                v-model="targetData"
                :props="{ key: 'id', label: 'name' }"
                :data="transferdata"
            ></el-transfer>
        </div>
        <span slot="footer">
            <el-button type="info" icon="el-icon-close" @click="close"
                >取消</el-button
            >
            <el-button type="primary" icon="el-icon-check" @click="save"
                >同步数据</el-button
            >
        </span>
        <step ref="voucherCreateStep"></step>
    </el-dialog>
</template>

<script>
import axios from 'axios'
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import step from './voucherCreateCloudOrZ5Step'
export default {
    components: {
        step
    },
    data() {
        return {
            targetData: [],
            selfVisible: false,
            selfLoading: false,
            transferdata: [],
            orderTypeList: [],
            voucherQueryModel: {},
            searchData: {},
            saveApi:
                config.BASE_Middle_API +
                'VoucherCreate/MutilShopsCloudDataHandle'
        }
    },
    methods: {
        renderFunc(h, option) {
            return <span title={option.id + option.name}>{option.name}</span>
        },
        filterMethod(query, item) {
            return item.name.indexOf(query) > -1
        },
        createDialog(
            visible,
            data,
            voucherQueryModel,
            searchData,
            orderTypeLists
        ) {
            this.selfVisible = visible
            this.transferdata = data
            this.voucherQueryModel = voucherQueryModel
            this.searchData = searchData
            this.orderTypeList = orderTypeLists
        },
        save() {
            const _this = this
            const confirmData = {
                brandID: _this.voucherQueryModel.brandId,
                //orderTypeID: _this.voucherQueryModel.orderType,
                billNo: _this.searchData.billNo,
                otherSideName: _this.searchData.otherSideName,
                otherWarehouseName: _this.searchData.otherWarehouseName,
                billBusTypes: _this.searchData.billBusTypes,
                billTypes: _this.searchData.billTypes,
                totalIncloudTaxMoneyMin:
                    _this.searchData.totalIncloudTaxMoneyMin,
                totalIncloudTaxMoneyMax:
                    _this.searchData.totalIncloudTaxMoneyMax,
                startTime: _this.searchData.startTime,
                endTime: _this.searchData.endTime,
                storeIDs: _this.targetData,
                groupType: _this.voucherQueryModel.groupType,
                orderIds: _this.voucherQueryModel.orderIds,
                orderState: _this.searchData.orderState,
                makeOrderState: _this.searchData.makeOrderState,
                orgName: _this.searchData.orgName,
                isYSYF: _this.voucherQueryModel.isYSYF,
                isSSSF: _this.voucherQueryModel.isSSSF,
                tick: _this.voucherQueryModel.tick
            }
            var totalCount = 0
            if (_this.voucherQueryModel.orderIds.length == 0) {
                totalCount = _this.voucherQueryModel.vouchernumber
            } else {
                totalCount = _this.voucherQueryModel.orderIds.length
            }
            let orderTypeNameList = []
            let billTypeList = []
            if (
                confirmData.billTypes != '' &&
                confirmData.billTypes != null &&
                confirmData.billTypes != 'undefined'
            ) {
                billTypeList = confirmData.billTypes.split(',')
            } else {
                confirmData.billTypes = ''
            }
            billTypeList.forEach((t) => {
                const storeItem = this.orderTypeList.filter(
                    (x) => x.billTypeId == t
                )
                orderTypeNameList.push(storeItem[0].billTypeName)
            })
            confirmData.billTypeNames = orderTypeNameList
            let storeNameList = []
            let storeList = confirmData.storeIDs
            storeList.forEach((t) => {
                const storeItem = this.transferdata.filter((x) => x.id == t)
                storeNameList.push(storeItem[0].name)
            })
            confirmData.storeNames = storeNameList
            _this.$refs.voucherCreateStep.showParams(confirmData)
            _this.$refs.voucherCreateStep.beginStep(confirmData, totalCount)
            if (confirmData.isSSSF || confirmData.isYSYF) {
                _this.$refs.voucherCreateStep.successstep1(totalCount)
                AjaxHelper.post(_this.saveApi, confirmData)
                    .then(function (response) {
                        if (response.result.isSuccess) {
                            _this.$refs.voucherCreateStep.successstep2()
                        } else {
                            _this.$refs.voucherCreateStep.failstep2(
                                response.result.voucherHandleInfos
                            )
                        }
                        _this.targetData = []
                    })
                    .catch(function (error) {
                        _this.$refs.voucherCreateStep.failstep2(error.message)
                    })
            } else {
                AjaxHelper.post(
                    config.BASE_Middle_API +
                        'VoucherCreate/CheckErrorBasicDatas',
                    confirmData
                )
                    .then(function (response) {
                        if (response.result.length > 0) {
                            _this.$refs.voucherCreateStep.failstep1(
                                response.result
                            )
                        } else {
                            _this.$refs.voucherCreateStep.successstep1(
                                totalCount
                            )
                            AjaxHelper.post(_this.saveApi, confirmData)
                                .then(function (response) {
                                    if (response.result.isSuccess) {
                                        _this.$refs.voucherCreateStep.successstep2()
                                    } else {
                                        _this.$refs.voucherCreateStep.failstep2(
                                            response.result.voucherHandleInfos
                                        )
                                    }
                                    _this.targetData = []
                                })
                                .catch(function (error) {
                                    _this.$refs.voucherCreateStep.failstep2(
                                        error.message
                                    )
                                })
                        }
                    })
                    .catch(function (error) {
                        _this.$refs.voucherCreateStep.errorstep1(error.message)
                    })
            }
        },
        close() {
            this.selfVisible = false
        }
    }
}
</script>
<style>
.el-transfer-panel {
    width: 254px;
}
</style>
